export default __webpack_public_path__ + "static/favicon-192x192-194f683d5074db619ae7a00215ef3243.png";